import { forwardRef } from 'react';
import { Input, InputGroup, InputGroupProps, InputProps } from '@chakra-ui/react';

export interface TextInputProps extends InputProps {
  inputGroupProps?: Omit<InputGroupProps, 'children'>;
  children?: InputGroupProps['children'];
}
export type InputRef = HTMLInputElement;

/**
 * @description -
 * Base input component which can be used to compose other input components.
 * Pass children to this component to add additional elements to the input group.
 * Examples can be found in the [Chakra UI docs](https://chakra-ui.com/docs/form/input)
 * Wrap this component in FormControl for use inside a form.
 * @example
 * <TextInput />
 * <TextInput placeholder="Search">
 *   <InputLeftElement>
 *    <SearchIcon />
 *   </InputLeftElement>
 * </TextInput>
 */
const TextInput = forwardRef<InputRef, TextInputProps>(
  ({ size, inputGroupProps, children, ...inputProps }, ref) => {
    return (
      <InputGroup height="100%" w={inputProps.w ?? inputProps.width} {...inputGroupProps}>
        <>
          <Input visual="primary" type="text" size={size} ref={ref} {...inputProps} />
          {children}
        </>
      </InputGroup>
    );
  },
);

export default TextInput;
